export enum JourneyCompanyType{
    Limited, LLP, SoleTrader
}

export type CompanyTypes = "Limited" | "LLP" | "SoleTrader";